"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.namings = exports.OPPORTUNITY_TYPE_VALUE = exports.JOURNEY_VALUE = void 0;
const namings = exports.namings = {
  notify: {
    name: 'unlock data',
    alternate: 'unlock data'
  },
  success: {
    name: 'unlock data request sent',
    alternate: 'unlock data request'
  },
  error: {
    name: 'unlock data request failed',
    alternate: 'unlock data request fail'
  }
};
const OPPORTUNITY_TYPE_VALUE = exports.OPPORTUNITY_TYPE_VALUE = 'Upsell';
const JOURNEY_VALUE = exports.JOURNEY_VALUE = 'Analytics';